import {IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';
import {IFormulaireClass} from '../../../../../core/services/formulaire/formulaire.service';
import {IFormulaireItemClass} from '../../../../../core/services/formulaire/formulaire-item.service';
import {IParametresRechercheService} from '../../../../../core/services/parametres-recherche.service';
import {IMenuClass} from '../../../../../core/services/menu/menu.service';
import {IFilterLibelle} from '../../../../../core/filters/ex-libelle.filter';

interface IPageMr0264 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Mr0264Controller(Menu: IMenuClass,
                                         parametresRecherche: IParametresRechercheService,
                                         exLibelleFilter: IFilterLibelle,
                                         Formulaire: IFormulaireClass,
                                         FormulaireItem: IFormulaireItemClass) {
    const vm: IPageMr0264 = this;

    vm.multiOccurrenceOptions = {
        fonctions: {
            importation: true
        },
        colonnesVisibles: [
            {nom: 'sgncod', largeur: 90},
            {nom: 'sgndsc', largeur: 300}
        ],
        formulaire: new Formulaire([
            new FormulaireItem('sgncod', {required: true}),
            new FormulaireItem('sgndsc', {required: true})
            ],
            {largeurDefaut: 50}
        )
    };
}
